import React from 'react';
import { FolderFileLight } from '@ha/icons';
import { units, Link, Typography } from '@hbf/dsl';
import { makeStyles } from 'tss-react/mui';
import { useIntl } from 'ha/i18n';

const useStyles = makeStyles()(theme => ({
  root: {
    padding: theme.spacing(2, 2, 0, 2),
  },
  link: {
    color: theme.palette.secondary.main,
  },
  icon: {
    color: theme.palette.grey[700],
    fontSize: units.rem(1),
    marginRight: units.rem(0.5),
    verticalAlign: 'middle',
  },
}));

interface Props {
  hasMargins?: boolean;
  name: string;
  sharedDocumentsCount?: number;
  onShowSharedDocuments?: () => void;
}

const UserCardSharedDocuments: React.FC<Props> = ({
  hasMargins = false,
  name,
  sharedDocumentsCount = 0,
  onShowSharedDocuments = () => {},
}) => {
  const { classes } = useStyles();
  const { T } = useIntl();

  const handleClick = React.useCallback(
    (evt: React.MouseEvent) => {
      evt.preventDefault();
      if (onShowSharedDocuments) {
        onShowSharedDocuments();
      }
    },
    [onShowSharedDocuments],
  );

  return sharedDocumentsCount > 0 ? (
    <Link to="" onClick={handleClick}>
      <Typography.Caption
        className={hasMargins ? classes.root : undefined}
        overflow="ellipsis"
        data-test-locator="User Card Shared Documents"
      >
        <FolderFileLight className={classes.icon} />
        <span className={classes.link}>
          {T('doc.view_%s_label', name, sharedDocumentsCount)}
        </span>
      </Typography.Caption>
    </Link>
  ) : (
    <Typography.Caption
      className={hasMargins ? classes.root : undefined}
      overflow="ellipsis"
      data-test-locator="User Card Shared Documents"
    >
      <FolderFileLight className={classes.icon} />
      {T('doc.0_docs_from_%s_label', name)}
    </Typography.Caption>
  );
};

export { UserCardSharedDocuments };
